export default class Events {
    static CLICK_ON_BACKGROUND_LAYER_EVENT = 'clickOnBackgroundLayer'
    static OPEN_NAVBAR_EVENT = 'openNavbar'
    static CLOSE_NAVBAR_EVENT = 'closeNavbar'
}
